import { FormType } from '../../../form-types';
import { SermorelinFollowupFieldAnswers } from '../questions';

const sermorelinFollowup: FormType<SermorelinFollowupFieldAnswers> = {
  name: 'Metabolic Support Follow-up Consultation',
  questions: [
    {
      key: 'sermorelinFollowup_sexAssignedAtBirth',
      next: {
        condition: {
          'sermorelinFollowup_sexAssignedAtBirth.female': true
        },
        key: 'sermorelinFollowup_pregnancyStatus',
        els: 'generic_heightWeight2025'
      }
    },
    {
      key: 'sermorelinFollowup_pregnancyStatus',
      next: {
        switch: [
          {
            condition: {
              'sermorelinFollowup_pregnancyStatus.yes': true
            },
            key: 'sermorelinFollowup_ineligible'
          }
        ],
        els: 'sermorelinFollowup_pregnancyConsent'
      }
    },
    {
      key: 'sermorelinFollowup_pregnancyConsent',
      next: {
        switch: [
          {
            condition: {
              'sermorelinFollowup_pregnancyConsent.non_consent': true
            },
            key: 'sermorelinFollowup_didNotConsent'
          }
        ],
        els: 'generic_heightWeight2025'
      }
    },
    'generic_heightWeight2025',
    {
      key: 'sermorelinFollowup_healthChanges',
      next: {
        condition: {
          'sermorelinFollowup_healthChanges.yes': true
        },
        key: 'sermorelinFollowup_healthChangesDetails',
        els: 'sermorelinFollowup_medicationDoing'
      }
    },
    'sermorelinFollowup_healthChangesDetails',
    {
      key: 'sermorelinFollowup_medicationDoing',
      next: {
        condition: {
          'sermorelinFollowup_medicationDoing.not_well': true
        },
        key: 'sermorelinFollowup_medicationExperience',
        els: 'sermorelinFollowup_activelyTaking'
      }
    },
    'sermorelinFollowup_medicationExperience',
    {
      key: 'sermorelinFollowup_activelyTaking',
      next: {
        condition: {
          'sermorelinFollowup_activelyTaking.no': true
        },
        key: 'sermorelinFollowup_lastTaken',
        els: 'sermorelinFollowup_sideEffects'
      }
    },
    'sermorelinFollowup_lastTaken',
    {
      key: 'sermorelinFollowup_sideEffects',
      next: {
        condition: {
          'sermorelinFollowup_sideEffects.yes': true
        },
        key: 'sermorelinFollowup_sideEffectsDetails',
        els: 'sermorelinFollowup_diagnosedConditions'
      }
    },
    'sermorelinFollowup_sideEffectsDetails',
    {
      key: 'sermorelinFollowup_diagnosedConditions',
      next: {
        switch: [
          {
            condition: {
              'sermorelinFollowup_diagnosedConditions.active_cancer': true
            },
            key: 'sermorelinFollowup_ineligible'
          },
          {
            condition: {
              'sermorelinFollowup_diagnosedConditions.hypothyroidism': true
            },
            key: 'sermorelinFollowup_thyroidControl'
          }
        ],
        els: 'sermorelinFollowup_medications_new'
      }
    },
    {
      key: 'sermorelinFollowup_thyroidControlConsent',
      next: {
        switch: [
          {
            condition: {
              'sermorelinFollowup_thyroidControlConsent.non_consent': true
            },
            key: 'sermorelinFollowup_didNotConsent'
          }
        ],
        els: 'sermorelinFollowup_medications_new'
      }
    },
    {
      key: 'sermorelinFollowup_medications_new',
      next: {
        switch: [
          {
            condition: {
              'sermorelinFollowup_medications_new.muscarinic_antagonist': true
            },
            key: 'sermorelinFollowup_ineligible'
          },
          {
            condition: {
              'sermorelinFollowup_medications_new.somatostatin': true
            },
            key: 'sermorelinFollowup_ineligible'
          },
          {
            condition: {
              'sermorelinFollowup_medications_new.propylthiouracil': true
            },
            key: 'sermorelinFollowup_ineligible'
          }
        ],
        els: 'sermorelinFollowup_additionalQuestions'
      }
    },
    'sermorelinFollowup_additionalQuestions',
    'sermorelinFollowup_complete',
    'sermorelinFollowup_ineligible',
    'sermorelinFollowup_didNotConsent'
  ]
};

export default sermorelinFollowup;
